import { render, staticRenderFns } from "./Inscricao.vue?vue&type=template&id=3553dd9e&scoped=true&"
import script from "./Inscricao.vue?vue&type=script&lang=js&"
export * from "./Inscricao.vue?vue&type=script&lang=js&"
import style0 from "./Inscricao.vue?vue&type=style&index=0&id=3553dd9e&lang=scss&scoped=true&"
import style1 from "./Inscricao.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553dd9e",
  null
  
)

export default component.exports